import React from 'react'
import { Offcanvas, OverlayTrigger } from 'react-bootstrap'
import TooltipCustom from "react-bootstrap/Tooltip";
import { formatNumbers, formatSmartDecimal, getTokenSymbol } from '../../utils/helpers';
import { NETWORK_FEES } from '../../utils/constants';
import { useSwipeClose } from '../../hooks/useSwipeClose';


const ProposedResolutionCanvas = ({ show, onHide, bondAmount, tokenSymbol, onSubmit, gasEstimateInUsdt, gasFeesSpinner, ownermatch, isAiResolver }) => {
    const swipeRef = useSwipeClose(show, onHide);
    return (
        <>
            <Offcanvas
                placement={window.innerWidth > 991 ? "end" : "bottom"}
                className="reasoningoffcanvas new-offcanvas-style-mobile"
                show={show}
                onHide={onHide}
            >
                {
                    window.innerWidth > 991 ? (
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                                Close the market
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                    ) : (
                        <Offcanvas.Header ref={swipeRef}>
                            <span className='mobile-swap-close d-none'></span>
                        </Offcanvas.Header>
                    )
                }
                <Offcanvas.Body>
                    <div className="propose-resolution-parent">
                        <div className="main-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M17.025 33H9C8.20435 33 7.44129 32.6839 6.87868 32.1213C6.31607 31.5587 6 30.7957 6 30V6.00001C6 5.20436 6.31607 4.4413 6.87868 3.87869C7.44129 3.31608 8.20435 3.00001 9 3.00001H21C21.4753 2.99885 21.9462 3.09183 22.3854 3.27359C22.8246 3.45535 23.2235 3.72229 23.559 4.05901L28.941 9.44101C29.2777 9.77652 29.5447 10.1754 29.7264 10.6146C29.9082 11.0538 30.0012 11.5247 30 12V20.025" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M21 3V10.5C21 10.8978 21.158 11.2794 21.4393 11.5607C21.7206 11.842 22.1022 12 22.5 12H30" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M21 28.5H30" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M25.5 24V33" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <h6>{isAiResolver ? "Resolve Market with AI" : "Resolve Market"} </h6>
                        <p className="para mb-0">AI will automatically determine the market outcome based on available data. This process does not require you to select an outcome and cannot be reversed once started.</p>

                    </div>
                    <div className="createdispute-options">
                        <div className="parent-resolution-bond">
                            <div className="resolution-bond">
                                <div className="upper-text" style={ownermatch ? { borderBottom: "1px solid transparent" } : {}}>
                                    <h6>AI Resolution Bond <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                <h6>This payment confirms that the outcome already exists.</h6>
                                                <p>Refunded only if the AI verifies the outcome. If verification fails or is Too Early, the bond is forfeited.</p>
                                            </TooltipCustom>
                                        }
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <g clipPath="url(#clip0_10136_49160)">
                                                <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M7 9.33333V7" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M7 4.6665H7.01" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_10136_49160">
                                                    <rect width="14" height="14" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </OverlayTrigger></h6>
                                    <h5>
                                        {ownermatch ? (
                                            <>
                                                <span>0</span>
                                                <span style={{ textDecoration: "line-through" }}>
                                                    {getTokenSymbol(tokenSymbol)}{formatNumbers(+bondAmount) ?? '...'}
                                                </span>
                                            </>
                                        ) : (
                                            <span>
                                                {getTokenSymbol(tokenSymbol)}{formatNumbers(+bondAmount) ?? '...'}
                                            </span>
                                        )}
                                    </h5>
                                </div>
                                {ownermatch && <div className="bottom-text">Creator Discount Applied</div>}
                            </div>
                            <div className="resolution-bond">
                                <div className="upper-text">
                                    <h6>Estimated {NETWORK_FEES}</h6>
                                    <h5>
                                        {gasFeesSpinner ? (
                                            <span className="spinner" />
                                        ) : (
                                            `$${formatSmartDecimal(gasEstimateInUsdt)}`
                                        )}
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div className="orange-text">
                            <p>If a dispute is raised, the AI-verified outcome may be reviewed or overturned.</p>
                        </div>
                    </div>


                    <div className="twice-btns twice-btns-new-canvas" style={{ gridTemplateColumns: "1fr" }}>
                        <button
                            className='btn-proposal'
                            disabled={gasFeesSpinner || +gasEstimateInUsdt === 0}
                            onClick={onSubmit}
                        >
                            {gasFeesSpinner ? 'Loading...' : 'Submit Proposal'}
                        </button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default ProposedResolutionCanvas
